export default {
	rtl: false,
	header: {
		title: 'votre panier',
	},
	empty_cart: '',
	shipping_option: 'livraison standard',
	product: {
		sold_out: 'épuisé',
	},
	product_details: {
		atcButton: { text: 'ajouter au panier' },
		readMore: { text: 'voir plus' },
	},
	modules: {
		checkout_button: {
			button_text: { text: 'check-out' },
			button_text_loading: { text: 'générer une offre...' },
			use_coupon_code: { text: 'code de coupon' },
			enter_coupon_code: { text: 'entrez le coupon' },
			apply_coupon_code: { text: 'appliquer' },
			edit_coupon_code: { text: 'modifier' },
			close_coupon_code: { text: 'fermer' },
			subtotal: { text: 'total' },
			savings: { text: 'remise' },
			coupon_alert_text: { text: 'Le code remplace les autres offres' },
		},
		random_text: {
			text: '<p class="ql-align-center">100% NO-RISK MONEY BACK GUARANTEE</p>',
		},
		order_note: {
			text: '<p> <strong>Ajoutez une note</strong></p>',
		}
	},
	campaigns: {
		bundles: {
			text: 'Achetez {{quantity}} économisez {{discount}}',
			prefix: '{{individual_price}} chacun',
		},
		add_to_unlock: {
			title: {
				text: 'fréquemment achetés ensemble',
			},

			show_product_details: {
				text: 'afficher les détails',
			},
			upsell_add_button: {
				text: 'ajouter au panier',
			},
			upsell_confirm_button: {
				text: 'confirmer',
			},
			discount: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'> ajoutez <b>{{amount_left}}</b> pour débloquer <b>{{award}}</b> de réduction<p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> vous avez débloqué <b>{{reward}}</b><p>",
			},
			free_shipping: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'>  ajoutez <b>{{amount_left}}</b> pour bénéficier de <b>la livraison gratuite</b><p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> La livraison est <b>GRATUITE</b><p>",
			},
			separator: {
				text: 'OU',
			},
			gift: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'> Add <b>{{amount_left}}</b> to get a <b>Free Gift</b><p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> You've unlocked a <b>Free Gift</b><p>",
				compare_at_price: {
					text: "{{compare_at_price}}"
				},
				widget: {
					before: {
						header:
							"Spend {{goal}} Get A Free Gift 🎁",
						product_name: "Free gift: {{product_name}}",
						offer_highlight: {
							text: "Free"
						},
					},
					after: {
						header:
							"Hurry! This offer is only valid today! ⏰",
						product_name: "<p><b>You unlocked this! 🎉</b></p><p>Free gift: {{product_name}}</p>",
						offer_highlight: {
							text: "Free"
						},
					}

				}
			}
		},
		one_check_up_sell: {
			text: '<p>🔥 ajouter {{title}} pour {{price}}</p>',
		},
	},
};
